import React from 'react'
import { useState } from 'react';
import SingleBlog3Img1 from '../assets/images/blog/single_blog3img1.jpg'
import Blog1Img2 from '../assets/images/blog/blog1-img2.jpg'
import Blog1Img3 from '../assets/images/blog/blog1-img3.jpg'
import BlogImgGroup from '../assets/images/blog/blog-img-group.jpg'
import Telephone from '../assets/images/services/telephone.png'
import YouTubeLogo from '../assets/images/services/youtube-logo.png'
import FixHeader from '../component/FixHeader'
import Loader from '../component/Loader'
import LatestBlog from '../component/LatestBlog'
import Footer from '../component/Footer'
import { useNavigate } from 'react-router-dom';


const BlogDetails2 = () => {
    const navigate = useNavigate()
    const [isPlaying, setIsPlaying] = useState(false);
    const playVideo = () => {
        setIsPlaying(true);
    };
    return (
        <>
            <Loader />
            <FixHeader />
            {/* <!-- ====================================== Services Section One ===================================== --> */}
            <section className="section-breadcrumb-img" id="blog-section-one">
                <div className="container breadcrumb-main">
                    <h1 className="about-h1-text" data-aos="fade-down">Single Blog</h1>
                    <ul className="breadcrumb-list about-breadcrumb aos-init aos-animate" data-aos="fade-up">
                        <li className="line-slash" onClick={() => navigate("/")}>Home</li>
                        <li className="line-slash" onClick={() => navigate("/BlogDetails2")}>Blog</li>
                        <li className="active-breadcrumb" onClick={() => navigate("/BlogDetails2")}>Single Blog 2</li>
                    </ul>
                </div>
            </section>
            {/* <!-- ====================================== Services Section Two ===================================== --> */}
            <section className="about-section-two pb-0 overflow-hidden">
                <div className="container">
                    <div className="row single-services1-row single-services2-row">
                        <div className="col-xxl-4 col-xl-4 col-lg-6 col-md-8">
                            <div className="other-services-main" data-aos="fade-left" id="other-services-main-blog">
                                <div className="blog-form" id="blog-form">
                                    <input type="text" placeholder="Search" name='Search' />
                                    <svg className="search-svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                                        <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                                        <g id="SVGRepo_iconCarrier">
                                            <path
                                                d="M15.7955 15.8111L21 21M18 10.5C18 14.6421 14.6421 18 10.5 18C6.35786 18 3 14.6421 3 10.5C3 6.35786 6.35786 3 10.5 3C14.6421 3 18 6.35786 18 10.5Z"
                                                stroke="#071B35" strokeWidth="2" strokeLinecap="round"
                                                strokeLinejoin="round"></path>
                                        </g>
                                    </svg>
                                </div>
                            </div>
                            <div className="side-bar-main category-main" data-aos="fade-right">
                                <h2 className="d-none">hidden</h2>
                                <h3 className="ServicesList-Text case-info-text">Category</h3>
                                <ul className="newsBlog-List">
                                    <li>Fiction Writers</li>
                                    <li>Content Writers</li>
                                    <li>Digital Writers</li>
                                    <li>Business Writers</li>
                                    <li>Technical Writers</li>
                                    <li>Marketing Writers</li>
                                </ul>
                            </div>
                            <div className="contact-side-bar aos-init aos-animate" data-aos="fade-up">
                                <img className="telephone-img" src={Telephone} alt="call" />
                                <h4>Get In Touch</h4>
                                <p className="resolving">Ready to assist you in resolving any issues you may have.</p>
                                <div className="hire-me-btn-main">
                                    <div onClick={() => navigate("/Contact")} className="button button1" data-text="Contact">
                                        <span>Contact</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xxl-8 col-xl-8 col-lg-12 col-md-12">
                            <div className="video-container2 single-services-main-img">
                                {!isPlaying && (
                                    <>
                                        <img className="cover" src={SingleBlog3Img1} alt="Video Cover" />
                                        <img className="play-button" src={YouTubeLogo} alt="Play Button" onClick={playVideo} />
                                    </>
                                )}
                                <div className="video-wrapper">
                                    {isPlaying && (
                                        <iframe
                                            id="youtube-video"
                                            src="https://www.youtube.com/embed/TqFU1vle48k?si=wBcN42ZkO_ble_yy-&autoplay=1"
                                            frameBorder="0"
                                            allow="autoplay; encrypted-media"
                                            allowFullScreen
                                            title="YouTube Video"
                                        ></iframe>
                                    )}
                                </div>
                            </div>
                            <h2 className="Singleservices-text-main Singleservices-text-main2">How do you improve your content
                                writing skills?</h2>
                            <p className="commodo">Commodo semper bibendum adipiscing orci bibendum eu lectus sed. Commodo
                                cursus vitae augue luctus nibh. Congue sit quisque volutpat libero tempor a id cursus purus.
                                Pellentesque pellentesque scelerisque curabitur porta dolor. Amet vulputate vitae eget sit
                                rhoncus imperdiet. Odio justo nullam scelerisque quis bibendum. Cras ipsum vel diam praesent
                                tortor at elit sit. A risus molestie bibendum donec blandit adipiscing volutpat sollicitudin
                                aliquam. Nec arcu cras ultrices velit sed ligula. Iaculis elit vulputate sollicitudin
                                quisque ut faucibus.</p>
                            <p className="commodo pt-2">Facilisis nec malesuada enim viverra cras. Auctor dignissim tellus
                                vestibulum vitae hac amet. Suspendisse sit feugiat in pulvinar bibendum arcu nunc id. Duis
                                hac nisl dui facilisi placerat at mauris elit scelerisque. Turpis ornare auctor amet
                                vestibulum in magna aliquet ultricies netus. Adipiscing lobortis a interdum morbi etiam non.
                            </p>
                            <div className="small_blog" data-aos="fade-up">
                                <h3 className="integer">Mattis facilisis quam amet blandit faucibus. Sed in vitae
                                    montes sem quis faucibus bibendum massa. Eget volutpat molestie eget non netus nisl
                                    eleifend. Sit pellentesque posuere vitae scelerisque vel aliquet vulputate purus. Ac
                                    risus neque sed at pellentesque ultrices.
                                </h3>
                                <div className="line_client">
                                    <div className="line"></div>
                                    <h4 className="jordon">By Jordon Smith</h4>
                                </div>
                            </div>
                            <div className="single-services-imgs-group">
                                <img src={Blog1Img2} alt="Blog1Img2" />
                                <img src={Blog1Img3} alt="Blog1Img3" />
                            </div>
                            <div className="img-animation-style2 reveal">
                                <img className="coming_soon_bg_blog" src={BlogImgGroup} alt="blog-img-group" />
                            </div>
                            <p className="commodo">Facilisis nec malesuada enim viverra cras. Auctor dignissim tellus vestibulum
                                vitae hac amet. Suspendisse sit feugiat in pulvinar bibendum arcu nunc id. Duis hac nisl dui
                                facilisi placerat at mauris elit scelerisque. Turpis ornare auctor amet vestibulum in magna
                                aliquet ultricies netus. Adipiscing lobortis a interdum morbi etiam non. Elit sed magna
                                risus tempor non quis. Nec pulvinar scelerisque in faucibus.</p>
                            <p className="commodo pt-2">Dis morbi cursus aliquam rutrum tortor amet. Mauris consequat libero
                                praesent pellentesque nibh sed eget urna. Leo at feugiat vel dictum eget quam et commodo
                                nullam. Nec arcu egestas adipiscing mollis dapibus justo non.</p>
                            <div className="button-container aos-init aos-animate" data-aos="fade-up">
                                <button>
                                    <svg className="prev-arrow-blog" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                        viewBox="0 0 24 24" fill="none">
                                        <g clipPath="url(#clip0_282_13)">
                                            <path d="M5 12H19" stroke="white" strokeWidth="2" strokeLinecap="round"
                                                strokeLinejoin="round"></path>
                                            <path d="M5 12L9 16" stroke="white" strokeWidth="2" strokeLinecap="round"
                                                strokeLinejoin="round"></path>
                                            <path d="M5 12L9 8" stroke="white" strokeWidth="2" strokeLinecap="round"
                                                strokeLinejoin="round"></path>
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_282_13">
                                                <rect width="24" height="24" fill="white"></rect>
                                            </clipPath>
                                        </defs>
                                    </svg>Prev
                                </button>
                                <div className="share-button view-modal">
                                    <button>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                            fill="none">
                                            <g clipPath="url(#clip0_282_25)">
                                                <path
                                                    d="M3 12C3 12.7956 3.31607 13.5587 3.87868 14.1213C4.44129 14.6839 5.20435 15 6 15C6.79565 15 7.55871 14.6839 8.12132 14.1213C8.68393 13.5587 9 12.7956 9 12C9 11.2044 8.68393 10.4413 8.12132 9.87868C7.55871 9.31607 6.79565 9 6 9C5.20435 9 4.44129 9.31607 3.87868 9.87868C3.31607 10.4413 3 11.2044 3 12Z"
                                                    stroke="white" strokeWidth="2" strokeLinecap="round"
                                                    strokeLinejoin="round"></path>
                                                <path
                                                    d="M15 6C15 6.79565 15.3161 7.55871 15.8787 8.12132C16.4413 8.68393 17.2044 9 18 9C18.7956 9 19.5587 8.68393 20.1213 8.12132C20.6839 7.55871 21 6.79565 21 6C21 5.20435 20.6839 4.44129 20.1213 3.87868C19.5587 3.31607 18.7956 3 18 3C17.2044 3 16.4413 3.31607 15.8787 3.87868C15.3161 4.44129 15 5.20435 15 6Z"
                                                    stroke="white" strokeWidth="2" strokeLinecap="round"
                                                    strokeLinejoin="round"></path>
                                                <path
                                                    d="M15 18C15 18.7956 15.3161 19.5587 15.8787 20.1213C16.4413 20.6839 17.2044 21 18 21C18.7956 21 19.5587 20.6839 20.1213 20.1213C20.6839 19.5587 21 18.7956 21 18C21 17.2044 20.6839 16.4413 20.1213 15.8787C19.5587 15.3161 18.7956 15 18 15C17.2044 15 16.4413 15.3161 15.8787 15.8787C15.3161 16.4413 15 17.2044 15 18Z"
                                                    stroke="white" strokeWidth="2" strokeLinecap="round"
                                                    strokeLinejoin="round"></path>
                                                <path d="M8.69922 10.7L15.2992 7.30005" stroke="white" strokeWidth="2"
                                                    strokeLinecap="round" strokeLinejoin="round">
                                                </path>
                                                <path d="M8.69922 13.3L15.2992 16.7" stroke="white" strokeWidth="2"
                                                    strokeLinecap="round" strokeLinejoin="round"></path>
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_282_25">
                                                    <rect width="24" height="24" fill="white"></rect>
                                                </clipPath>
                                            </defs>
                                        </svg>
                                    </button>
                                </div>
                                <button>Next
                                    <svg className="next-arrow-blog" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                        viewBox="0 0 24 24" fill="none">
                                        <g clipPath="url(#clip0_282_20)">
                                            <path d="M5 12H19" stroke="white" strokeWidth="2" strokeLinecap="round"
                                                strokeLinejoin="round"></path>
                                            <path d="M15 16L19 12" stroke="white" strokeWidth="2" strokeLinecap="round"
                                                strokeLinejoin="round"></path>
                                            <path d="M15 8L19 12" stroke="white" strokeWidth="2" strokeLinecap="round"
                                                strokeLinejoin="round"></path>
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_282_20">
                                                <rect width="24" height="24" fill="white"></rect>
                                            </clipPath>
                                        </defs>
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <LatestBlog />
            <Footer />
        </>
    )
}

export default BlogDetails2